import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M12 6.05A5.855 5.855 0 0 1 17.156 3C20.383 3 23 5.582 23 8.765c0 .114-.003.227 0 .34 0 7.46-9.823 12.607-9.823 12.607-.327.19-.756.288-1.185.288-.425 0-.847-.095-1.169-.288 0 0-9.823-5.146-9.813-12.607a5.553 5.553 0 0 1-.01-.34C1 5.582 3.617 3 6.844 3A5.855 5.855 0 0 1 12 6.05zm10 2.82v-.105C22 6.137 19.834 4 17.156 4c-1.81 0-3.44.985-4.277 2.526L12 8.146l-.879-1.62A4.854 4.854 0 0 0 6.844 4C4.166 4 2 6.137 2 8.765c0 .101.003.192.01.34-.004 2.928 1.696 5.76 4.577 8.363a26.054 26.054 0 0 0 4.75 3.386c.146.088.387.146.655.146.271 0 .525-.06.72-.173.066-.034.197-.107.387-.216a26.084 26.084 0 0 0 4.32-3.147c2.88-2.603 4.58-5.433 4.581-8.335a7.17 7.17 0 0 1 0-.258z"
});

var SvgLike = function SvgLike(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgLike;